import script from "./CapitalRu.vue?vue&type=script&setup=true&lang=js"
export * from "./CapitalRu.vue?vue&type=script&setup=true&lang=js"

import "./CapitalRu.vue?vue&type=style&index=0&id=178d44b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-178d44b8"]])

export default __exports__